import React from "react";
import { Link } from "react-router-dom";

const base =
  "group inline-flex items-center justify-center gap-2 whitespace-nowrap font-display font-semibold uppercase tracking-[0.12em] text-[12px] sm:text-[13px] transition-[background-color,color,border-color,box-shadow,transform] duration-300 will-change-transform";

const variants = {
  solid: "bg-grn text-white hover:bg-grn-light hover:-translate-y-0.5 shadow-[0_10px_30px_-12px_rgba(5,150,105,0.65)]",
  navy: "bg-navy text-white hover:bg-navy-700 hover:-translate-y-0.5 shadow-[0_10px_30px_-14px_rgba(10,25,47,0.6)]",
  outline: "border border-navy/25 text-navy hover:border-navy hover:bg-navy hover:text-white",
  ghostLight: "border border-white/25 text-white hover:border-white hover:bg-white hover:text-navy",
  gold: "bg-gold text-navy hover:bg-gold-light hover:-translate-y-0.5",
  link: "text-grn hover:text-navy underline-offset-4 hover:underline px-0 py-0",
};

const sizes = {
  md: "px-6 py-3.5",
  sm: "px-4 py-2.5 text-[11px]",
  lg: "px-8 py-4",
};

export const Btn = ({
  children,
  variant = "solid",
  size = "md",
  to,
  href,
  external,
  className = "",
  radius = "rounded-full",
  ...rest
}) => {
  const cls = `${base} ${variants[variant]} ${variant === "link" ? "" : sizes[size]} ${
    variant === "link" ? "" : radius
  } ${className}`;

  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  if (href)
    return (
      <a
        href={href}
        className={cls}
        {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
        {...rest}
      >
        {children}
      </a>
    );
  return <button type="button" className={cls} {...rest}>{children}</button>;
};

export const Eyebrow = ({ children, tone = "green", className = "" }) => (
  <span
    className={`overline inline-flex items-center gap-2.5 ${
      tone === "green" ? "text-grn" : tone === "gold" ? "text-gold" : "text-navy-300"
    } ${className}`}
  >
    <span className={`h-[1px] w-8 ${tone === "green" ? "bg-grn" : tone === "gold" ? "bg-gold" : "bg-navy-300"}`} />
    {children}
  </span>
);

export const Section = ({ children, className = "", dark = false, id, grid = false, ...rest }) => (
  <section
    id={id}
    className={`relative overflow-hidden ${dark ? "bg-navy text-white grain" : ""} ${className}`}
    {...rest}
  >
    {grid && (
      <div
        aria-hidden="true"
        className={`pointer-events-none absolute inset-0 ${dark ? "hairline-grid" : "hairline-grid-light"}`}
      />
    )}
    <div className="relative container">{children}</div>
  </section>
);

export const SectionTitle = ({ children, dark = false, className = "" }) => (
  <h2
    className={`font-display text-3xl sm:text-4xl lg:text-[3.25rem] leading-[1.05] font-semibold ${
      dark ? "text-white" : "text-navy"
    } ${className}`}
  >
    {children}
  </h2>
);

export const Lead = ({ children, dark = false, className = "" }) => (
  <p className={`text-sm sm:text-base leading-relaxed ${dark ? "text-navy-300" : "text-slate-600"} ${className}`}>
    {children}
  </p>
);
